import React, {useEffect, useState} from 'react';
import {readCandidatesFromTemExcelFile} from "@app/utils/CommonUtils";
import {LOCAL_STORAGE_USER_LOGIN_INFO, ResponseCode} from "@app/constants/Common";
import {Modal} from "react-bootstrap";
import Button from "react-bootstrap/Button";
import {requestCompareCandidatesFromList} from "@app/services/JobPipelineService";
import {alertMessage} from "@app/constants/Messages";

const CompareCandidatesFromExcelModal = (props) => {
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [headers, setHeaders] = useState([]);
    const [candidates, setCandidates] = useState([]);
    const [processing, setProcessing] = useState(false);
    const [userLoginInfo, setUserLoginInfo] = useState({});

    const {runJob, isShow, onClose} = props

    useEffect(() => {
        if (!userLoginInfo.id && localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)) {
            setUserLoginInfo(JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)))
        }
    }, [])

    const onSelectFiles = (event) => {
        setSelectedFiles(event.target.files);
    };

    const readUploadFile = (file) => {
        readCandidatesFromTemExcelFile(file, userLoginInfo.id, (cans, titles) => {
            setProcessing(true);
            const body = {job_id: runJob.job_id, candidates: cans}
            requestCompareCandidatesFromList(body).then((res) => {
                alertMessage(res.sts_code, false, true)
                if (res.sts_code === ResponseCode.SUCCESS) {
                    setHeaders(titles)
                    setCandidates(res.content)
                }
            }).catch((error) => {
                console.log(`Error:${JSON.stringify(error)}`);
            }).finally(() => {
                setProcessing(false);
            });
        })
    }

    const uploadExcelFile = async (e) => {
        e.preventDefault();
        if (selectedFiles.length === 0) return;
        setCandidates([]);

        readUploadFile(selectedFiles[0])
    };

    return (
        <Modal show={isShow}
               size={"xl"}
               onHide={onClose}
               animation={false}>
            <Modal.Header>
                <Modal.Title>Nhúng list excel</Modal.Title>
                <Button variant='secondary' onClick={onClose}>
                    Close
                </Button>
            </Modal.Header>
            <Modal.Body>
                <div className='container-fluid'>
                    <div className='card card-success'>
                        <div className='card-body'>
                            <form encType='multipart/form-data'>
                                <div className='form-group'>
                                    <div className='custom-file'>
                                        <input
                                            type='file'
                                            className='custom-file-input'
                                            id='customFile'
                                            name='file'
                                            onChange={(event) => onSelectFiles(event)}
                                        />
                                        <label
                                            className='custom-file-label'
                                            htmlFor='customFile'
                                        >
                                            {selectedFiles.length > 0 ? selectedFiles[0].name : ""}
                                        </label>
                                    </div>
                                </div>
                            </form>
                            <button
                                type='submit'
                                className='btn btn-success'
                                onClick={(e) => uploadExcelFile(e)}
                                disabled={processing}
                                data-toggle='modal' data-target='#inputCommonModal'
                                >
                                {processing ? 'Processing' : 'Upload'}
                            </button>
                        </div>
                        {candidates.length > 0 &&
                            <div className='card-body table-responsive'>
                            <table
                                className='table table-hover table-bordered text-nowrap text-center'
                                style={{
                                    maxHeight: '80vh',
                                    overflow: 'scroll',
                                }}
                            >
                                <thead>
                                <tr>
                                    {/*{headers.map(head => (*/}
                                    {/*    <th>{head}</th>*/}
                                    {/*))}*/}
                                    <th>STT</th>
                                    {/*<th>Person ID</th>*/}
                                    <th>SĐT di dộng(44)</th>
                                    <th>Email cá nhân (to send)(49)</th>
                                    <th>Email TỪNG dùng/lỗi(51)</th>
                                    <th>Email blocked(52)</th>
                                </tr>
                                </thead>
                                <tbody>
                                {candidates.map((can, index) => {
                                    return <tr key={`compare-candidate-excel_${index}`}>
                                        <td>{index + 1}</td>
                                        {/*<td>{can.id}</td>*/}
                                        <td>{can.phone}</td>
                                        <td>{can.email_to_send}</td>
                                        <td>{can.ever_email}</td>
                                        <td>{can.block_email}</td>
                                        {/*{Object.keys(row).map(field => (*/}
                                        {/*    <td key={`compare-candidate-excel-${index}-${field}`}>{arrayToString(row[field])}</td>*/}
                                        {/*))}*/}
                                    </tr>
                                })}
                                </tbody>
                            </table>
                        </div>
                        }
                    </div>
                </div>
            </Modal.Body>
        </Modal>

    );
};

export default CompareCandidatesFromExcelModal;
